import React, { useState } from "react";
import Navbar from "../components/Navbar";
import SongsOfTheDay from "./SongsOfTheDay";
import History from "./History";

const Homepage = ({ token }) => {
  const [currPage, setCurrPage] = useState("today");

  return (
    <div>
      <Navbar currPage={currPage} setCurrPage={setCurrPage} token={token} />
      <main style={{ backgroundColor: "rgb(24, 24, 24)" }}>
        {currPage === "today" && <SongsOfTheDay />}
        {currPage === "history" && <History />}
      </main>
    </div>
  );
};

export default Homepage;
